import styles from './DialogItem.module.scss'
import { ScoopText, ScoopRow, ScoopColumn, ScoopCenter } from '../../../../ui'

export const DialogItem = ({ icon, title, description, onClick, disabledStyles }) => {
    const containerClassName = `${styles.dialogItem} ${disabledStyles ? styles.dialogItemDisabled : ''}`

    return (
        <ScoopRow className={containerClassName} onClick={onClick}>
            <ScoopCenter className={styles.iconContainer}>
                {typeof icon === 'string' ? (
                    <img className={styles.iconImage} alt={'Plus icon'} src={icon} />
                ) : (
                    icon
                )}
            </ScoopCenter>
            <ScoopColumn>
                <ScoopText className={styles.title}>
                    {title}{' '}
                    {disabledStyles && (
                        <ScoopText className={styles.comingSoonBadge}>
                            {/* Coming soon! */}
                        </ScoopText>
                    )}
                </ScoopText>
                <ScoopText className={styles.description}>{description}</ScoopText>
            </ScoopColumn>
        </ScoopRow>
    )
}
